module.exports = __webpack_public_path__ + "static/media/wallet.4afe0588.svg";